(ns storrito.connect3.notification-approval-panel
  (:require [storrito.ui.button :as button]
            [storrito.connect3.common :as common]
            [storrito.util.link :as link]))

(defn trust-banner
  "Tells the user exactly which device and location the login request will
   show in their Instagram app, so the incoming notification looks expected
   instead of suspicious. Shared with the legacy notification panel
   (`storrito.connect3.two-factor-notification-panel`)."
  [state]
  (let [location (common/location-label state)]
    [:div.w-full.bg-gradient-to-r.from-blue-50.to-indigo-50.border.border-blue-200.rounded-xl.p-4.mb-4
     [:div.flex.items-start.gap-3
      [:div.h-10.w-10.rounded-full.bg-white.border.border-blue-200.flex.items-center.justify-center.flex-shrink-0
       [:i.fas.fa-mobile-alt.text-blue-600]]
      [:div.flex-1.text-left
       [:p.text-sm.font-semibold.text-gray-900.mb-1
        "What you'll see in Instagram"]
       [:p.text-sm.text-gray-700
        "A login request from a "
        [:b (common/device-label state)]
        (when location
          (list " in " [:b location]))
        "."]
       [:p.text-xs.text-gray-500.mt-1
        "That's us — Storrito connects through a server in your selected region so the login looks consistent to Instagram."]]]]))

(defn- step
  [{:keys [n title src alt]}]
  [:div.flex.flex-col.items-center
   [:div.flex.items-center.gap-1.mb-2
    [:span.h-6.w-6.rounded-full.bg-blue-600.text-white.text-xs.font-bold.flex.items-center.justify-center n]
    [:span.text-xs.font-medium.text-gray-700 title]]
   [:img.rounded-lg.border.border-gray-200.shadow-sm
    {:src src :alt alt :style {:width "140px"}}]])

(defn approve-steps
  "Screenshot walkthrough for approving the login request in the
   Instagram app. Shared with the legacy notification panel
   (`storrito.connect3.two-factor-notification-panel`)."
  []
  [:div.w-full.bg-gray-50.border.border-gray-200.rounded-xl.p-4.mb-4
   [:p.text-sm.font-semibold.text-gray-900.mb-3.flex.items-center
    [:i.fas.fa-list-ol.text-blue-600.mr-2]
    "Steps to approve"]
   [:div.flex.gap-3.flex-wrap.justify-center
    (step {:n 1 :title "Go to Home"
           :src "/img/instagram/2fa-notification/01.jpg"
           :alt "Instagram Home"})
    (step {:n 2 :title "Find the new device"
           :src "/img/instagram/2fa-notification/02.jpg"
           :alt "Account Center scrolled"})
    (step {:n 3 :title "Tap Approve"
           :src "/img/instagram/2fa-notification/03.jpg"
           :alt "Tap Approve"})]])

(defn panel
  [state]
  [:div.flex.items-center.justify-center
   [:div.bg-white.shadow-xl.rounded-2xl.px-8.pt-6.pb-6.max-w-5xl.w-full.mx-auto.flex.flex-col.items-center
    (common/instagram-logo)
    [:h2.text-2xl.font-bold.text-gray-900.mt-2.mb-1.text-center.w-full
     "Approve Your New Device"]
    [:p.text-sm.text-gray-500.text-center.mb-4
     "Open the Instagram app on your phone and tap "
     [:b "\"Approve\""]
     " on the login request."]

    (trust-banner state)

    (approve-steps)

    [:div.w-full
     [:a.inline-block.text-sm.text-blue-600.hover:underline.font-medium
      {:href (link/help-center-url "fd390648-13a9-47b3-affb-71a5aad2f636")
       :target "_blank"}
      [:i.fas.fa-question-circle.fa-sm.mr-1]
      "Need help? View detailed instructions"]
     (common/error-message state)
     (button/button-primary-lg
       {:class "w-full mt-3"
        :on {:click [[:connect3/send! {:device-approved true}]]}}
       "I have approved the new device")
     (button/button-secondary-lg
       {:class "w-full mt-2"
        :on {:click [[:connect3/send! {:device-approved false}]]}}
       "Try another way")]]])
